export let store = [];

const savedCart = localStorage.getItem('sd-catalog-cart');

if (savedCart) {
  store = JSON.parse(savedCart);
}
